/* models/renderers/data_renderer */ function _(require, module, exports) {
    var tslib_1 = require(426) /* tslib */;
    var renderer_1 = require(201) /* ./renderer */;
    var p = require(18) /* ../../core/properties */;
    var DataRendererView = /** @class */ (function (_super) {
        tslib_1.__extends(DataRendererView, _super);
        function DataRendererView() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        DataRendererView.__name__ = "DataRendererView";
        return DataRendererView;
    }(renderer_1.RendererView));
    exports.DataRendererView = DataRendererView;
    var DataRenderer = /** @class */ (function (_super) {
        tslib_1.__extends(DataRenderer, _super);
        function DataRenderer(attrs) {
            return _super.call(this, attrs) || this;
        }
        DataRenderer.initClass = function () {
            this.define({
                x_range_name: [p.String, 'default'],
                y_range_name: [p.String, 'default'],
            });
            this.override({
                level: 'glyph',
            });
        };
        DataRenderer.__name__ = "DataRenderer";
        return DataRenderer;
    }(renderer_1.Renderer));
    exports.DataRenderer = DataRenderer;
    DataRenderer.initClass();
}
